import { render } from "./select-from-dictionary.html?vue&type=template&id=e5013b14&scoped=true&ts=true"
import script from "./select-from-dictionary.ts?vue&type=script&lang=ts"
export * from "./select-from-dictionary.ts?vue&type=script&lang=ts"

import "./select-from-dictionary.scss?vue&type=style&index=0&id=e5013b14&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5013b14"]])

export default __exports__